<div class="section profile-device-training">
  <h4 class="mt0"><i class="fa icon-screen-smartphone fs20 vl-m mr"></i> Devices Training</h4>
  <app-devices [isTrainingDevice]="true" [patient]="patient"></app-devices>
</div>
